import React from 'react'
import { cn } from '../../lib/utils'

const STATUS_FROM_PCT = (pct) => {
  if (pct >= 0.9) return 'critical'
  if (pct >= 0.7) return 'warning'
  return 'ok'
}

const STATUS_BAR_CLASS = {
  ok: 'bg-emerald-500',
  warning: 'bg-amber-500',
  critical: 'bg-red-500',
}

const STATUS_LABEL_CLASS = {
  ok: 'text-zinc-600 dark:text-zinc-300',
  warning: 'text-amber-700 dark:text-amber-300',
  critical: 'text-red-700 dark:text-red-300',
}

const UNLIMITED_THRESHOLD = 5000

const UsageLimitWarning = ({ resource, current, max, className }) => {
  const isUnlimited = max === null || max === undefined || max >= UNLIMITED_THRESHOLD

  if (isUnlimited) {
    return (
      <div className={cn('flex items-center justify-between text-xs', className)}>
        <span className="text-zinc-600 dark:text-zinc-300">{resource}</span>
        <span className="text-zinc-500 dark:text-zinc-400">{current} (sin limite)</span>
      </div>
    )
  }

  const safeCurrent = Math.max(0, current || 0)
  const pct = max > 0 ? Math.min(safeCurrent / max, 1) : 0
  const status = STATUS_FROM_PCT(pct)

  return (
    <div data-status={status} className={cn('space-y-1', className)}>
      <div className="flex items-center justify-between text-xs">
        <span className="text-zinc-600 dark:text-zinc-300">{resource}</span>
        <span className={STATUS_LABEL_CLASS[status]}>
          {safeCurrent} / {max}
        </span>
      </div>
      <div className="h-1.5 w-full rounded-full bg-zinc-200 dark:bg-zinc-800">
        <div
          className={cn('h-full rounded-full transition-all', STATUS_BAR_CLASS[status])}
          style={{ width: `${Math.round(pct * 100)}%` }}
        />
      </div>
    </div>
  )
}

export default UsageLimitWarning
